import 'whatwg-fetch';

export default fetch; // eslint-disable-line no-undef
